"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cssValue = exports.cssPadding = exports.cssMargin = void 0;
var _stencilReactDesc = require("@amzn/stencil-react-desc");
// This must be a function so that a new PropType object is created each time,
// otherwise all props using this type will copy the same description
const cssValue = () => _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.number]);
exports.cssValue = cssValue;
const cssValueEdgeObject = _stencilReactDesc.PropTypes.shape({
  left: cssValue(),
  right: cssValue(),
  top: cssValue(),
  bottom: cssValue()
});
const cssValueArray = _stencilReactDesc.PropTypes.arrayOf(cssValue());
const cssMargin = () => _stencilReactDesc.PropTypes.oneOfType([cssValue(), cssValueArray, cssValueEdgeObject]);
exports.cssMargin = cssMargin;
const cssPadding = exports.cssPadding = cssMargin;